const PATH = '/subscription';

const extractResult = res => res.data.data.result;

export default client => ({
  create: () => client.post(PATH).then(extractResult),
  update: () => client.put(PATH).then(extractResult),
  delete: () => client.delete(PATH),
});
